import React from 'react';
import ReactDOM from 'react-dom/client'; // React 18 update
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HyperlinkProvider } from "./contexts/HyperlinkProvider";

const location = window.location.pathname.toLowerCase();
console.log(location);
const baseName = process.env.REACT_APP_BASENAME;

let basePath = baseName;
if (baseName === "/december2023") {
  basePath += "/";
}

// Create root instance for React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
	<HyperlinkProvider>
    <BrowserRouter>
      {location === baseName || location === "/december2023/" ? <App /> : null}
      {location !== baseName && location !== "/december2023/" ? <App /> : null}
    </BrowserRouter>
	</HyperlinkProvider>
  </React.StrictMode>
);

// Measure performance if needed
reportWebVitals();
